import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGallery } from '../api';
import AgentCard from '../components/AgentCard';
import CardGrid from '../components/CardGrid';

const GalleryPage = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getGallery()
      .then(res => setGallery(res.data))
      .catch(err => setError("Failed to fetch gallery"))
      .finally(() => setLoading(false));
  }, []);
  
  const handleTryIt = (genomeId) => {
    navigate(`/test/${genomeId}`);
  };

  if (loading) return <div>Loading public gallery...</div>;
  if (error) return <div style={{color: 'red'}}>{error}</div>;

  return (
    <div>
      <h2>Genome Gallery</h2>
      <p>Try out public agents created by other users.</p>
      <CardGrid>
        {gallery.map(genome => (
          <AgentCard 
            key={genome.metadata.genomeId} 
            genome={genome}
            onClick={() => handleTryIt(genome.metadata.genomeId)}
          />
        ))}
      </CardGrid>
    </div>
  );
};

export default GalleryPage;